/*************************************
 *
 * 微信认证授权
 * Author:smallsix@66629
 *
 *************************************/

import store from '../store/store'
import { getToken, getUserInfo } from './webCache'
import { getQueryString } from './customUtils'

// 微信 APPID
const WX_APPID = process.env.WX_CONFIG.WX_APP_ID

// 获取用户 token
const token = getToken()

export function wechatAuth (to, next) {
  if (!token) {
    // 获取微信认证 code
    let checkCode = getQueryString('code')
    // 如果木有code // 强制跳转，获取code
    if (!checkCode) {
      // 强制跳转，获取code
      window.location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        WX_APPID +
        '&redirect_uri=' +
        encodeURIComponent(document.URL) +
        '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
    } else {
      // 获取 微信授权 code
      let code = getQueryString('code')

      let params = {
        code: code,
        appid: WX_APPID
      }

      // 登录
      store.dispatch('user/wechatLogin', params).then(response => {
        if (response.code === 200) {
          window.location.href = to.fullPath
        } else {
          return false
        }
      })
    }
  } else {
    // 是否需要绑定手机号码
    if (to.meta.isBindMobile && getUserInfo() && !getUserInfo().member_mobile) {
      window.location.href = window.location.origin + '/shop/bindMobile'
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/wechatAuth.js